import { lazy, Suspense, useMemo } from "react"
import { Navigate, useRoutes } from "react-router-dom"
import useIsAiProcessing from "@/src/hooks/useIsAiProcessing"

import { SplashScreen } from "src/common/loading-screen"

import { authRoutes } from "./auth"
import { mainRoutes } from "./main"
import { dashboardRoutes } from "./dashboard"
import { postJobRoutes } from "./postJob"
import { useAppConfigStore } from "@/src/store"

// ----------------------------------------------------------------------

const LandingPage = lazy(() => import("src/pages/landing"))

export function Router() {
    const isAiProcessing = useIsAiProcessing()
    const appConfig = useAppConfigStore((state) => state.appConfig)
    const primaryRoutes = useMemo(
        () => dashboardRoutes(isAiProcessing ?? false, appConfig?.disableAddCandidates ?? false),
        [isAiProcessing, appConfig?.disableAddCandidates]
    )

    return useRoutes([
        {
            path: "/",
            element: (
                <Suspense fallback={<SplashScreen />}>
                    <LandingPage />
                </Suspense>
            ),
        },

        // Auth
        ...authRoutes,

        // Dashboard
        ...primaryRoutes,

        // Post Job
        ...postJobRoutes,

        // Main
        ...mainRoutes,

        // No match
        { path: "*", element: <Navigate to="/404" replace /> },
    ])
}
